import { useMemo } from 'react'
import styles from './CNDownloadPage.module.css'

function CNDownloadPage() {
  const IsPC = useMemo(() => {
    const userAgentInfo = navigator.userAgent
    const Agents = [
      'Android',
      'iPhone',
      'SymbianOS',
      'Windows Phone',
      'iPad',
      'iPod',
    ]
    let flag = true
    for (let v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
        flag = false
        break
      }
    }
    return flag
  }, [])

  return IsPC ? (
    <></>
  ) : (
    <div className={styles.root}>
      <div className={styles.content}>
        <img
          className={styles.img}
          src="https://wx-chargespot.oss-cn-shenzhen.aliyuncs.com/images/scan.png"
          alt=""
        />
        <span className={styles.text}>
          由于系统维护升级，暂不支持微信小程序扫码，请移步至支付宝。
          <br />
          对您造成不便，敬请谅解！
        </span>
      </div>
    </div>
  )
}

export default CNDownloadPage
